
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.819 1.328h0v8.758a.666.666 0 01-.19.474.796.796 0 01-.476.24h0H9.72v1.786a.67.67 0 01-.224.505.754.754 0 01-.533.209H1.495a.754.754 0 01-.533-.209.67.67 0 01-.224-.505V3.914a.67.67 0 01.224-.505.754.754 0 01.533-.209h2.342V1.414c0-.182.064-.341.19-.474A.796.796 0 014.505.7h7.558a.754.754 0 01.757.628zm-4.28 2.968h-6.64v7.908h6.64V4.296zm3.12-2.5h-6.66V3.2h3.964c.207 0 .385.07.533.209a.67.67 0 01.224.505v5.79h1.939V1.796z","fill":"#8dc540","stroke":"#000","stroke-width":".1"}})])
          )
        }
      }
    